import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { strings } from '@constants'
import { Textarea, TOAST_TYPE } from '@base'
import { Select, Calendar, Button } from '@baseV2'
import { toggleDrawer } from '@data/state/action/root'
import { showLoader, showToast } from '@data/state/action'
import { addTaskReminder } from '@data/conn/post/lead'
import { updateTaskReminder } from '@data/conn/put/leads'
import { FormBody, FormFooter, FormRow, FormSection } from './styles'

export const PRIORITY_OPTIONS = [
	{ id: 'LOW', label: 'Low' },
	{ id: 'MEDIUM', label: 'Medium' },
	{ id: 'HIGH', label: 'High' },
]

const AddTask = ({ leadId, update, task: existingTask }) => {
	const dispatch = useDispatch()
	const [dueDate, setDueDate] = useState(existingTask?.due_date || null)
	const [priority, setPriority] = useState(PRIORITY_OPTIONS.find((p) => p.id === existingTask?.priority) || {})
	const [followUp, setFollowUp] = useState(existingTask?.follow_up_message || '')

	const isEdit = Boolean(existingTask?.reminder_id)

	const handleSave = () => {
		if (!followUp.trim()) return
		const body = {
			due_date: dueDate || 0,
			follow_up_message: followUp,
			is_completed: Boolean(existingTask?.is_completed),
			priority: priority?.id || '',
		}
		const request = isEdit
			? updateTaskReminder(leadId, existingTask.reminder_id, { ...body, reminder_id: existingTask.reminder_id })
			: addTaskReminder(leadId, body)
		dispatch(showLoader(true))
		request
			.then(() => {
				dispatch(toggleDrawer(false))
			})
			.catch((err) => {
				dispatch(showToast(true, err?.response?.data?.message, { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				dispatch(showLoader(false))
				update?.()
			})
	}

	const handleCancel = () => {
		dispatch(toggleDrawer(false))
	}

	return (
		<>
			<FormBody>
				<FormRow>
					<Calendar label='Due Date' value={dueDate} placeholder='DD/MM/YYYY' minDate={new Date()} onChange={setDueDate} />
					<Select
						id='lead-task-priority'
						label='Priority'
						placeholder='Select'
						data={PRIORITY_OPTIONS}
						displayKey='label'
						primaryKey='id'
						value={priority}
						onChange={setPriority}
					/>
				</FormRow>
				<FormSection>
					<Textarea
						id='lead-task-follow-up'
						label='Follow-up Message'
						placeholder='Enter follow up message here...'
						value={followUp}
						onChange={setFollowUp}
						rows={6}
					/>
				</FormSection>
			</FormBody>

			<FormFooter>
				<Button size='base' onClick={handleSave} disabled={!followUp?.trim()}>
					{strings('save')}
				</Button>
				<Button size='base' variant='outline' onClick={handleCancel}>
					{strings('cancel')}
				</Button>
			</FormFooter>
		</>
	)
}

export default AddTask
